module.exports = __webpack_public_path__ + "static/img/01kursor.36644c70.png";